import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaBadge from './VaBadge.vue'

export default withConfigTransport(VaBadge)
